import { eDmGioiTinhActionsObj } from "../../action-types/category/IDmGioiTinhActions";
import { generateActions } from "../generateActions";

export const gioiTinhActions = {
  ...generateActions(eDmGioiTinhActionsObj, "GIOI_TINH"),
};
